var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxDisabledChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icone | Checkbox Checked Disabled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2a1 1 0 0 1-1-1V2Z",
    fill: "#B4BCC2",
    stroke: "#B4BCC2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7 10.6 3 8l-.9.9 3.7 3.7 8-8-1-.9-7 7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 10.6 3 8l-.9.9 3.7 3.7 8-8-1-.9-7 7",
    stroke: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxDisabledChecked);
export default __webpack_public_path__ + "static/media/CheckboxDisabledChecked.92b12b573dce59b5a7ede286018b52cd.svg";
export { ForwardRef as ReactComponent };